export default __webpack_public_path__ + "static/exame-e8df7605df48489aa61d00a65b4e3adb.png";